import React, { useState, useEffect } from 'react';
import '../Page.css';
import './InSight.css'
import { BsLaptop } from "react-icons/bs";
import { LuSmartphone } from "react-icons/lu";
import axios from 'axios';
import MainLoader from '../../Components/UI-Controls/MainLoader/MainLoader';
import BottomToust from "../../Components/BottomToust/BottomToust";
import { IoIosArrowDown } from "react-icons/io";

import { CircularProgressbar } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';

import { FaSquareFull } from "react-icons/fa6";
import { FaCircle } from "react-icons/fa";
import { IoTriangleSharp } from "react-icons/io5";
import { baseURL, security_key, Url } from '../../Services/Api';
import InsightsHistory from './insightsHistory';

const InSights = () => {
  const [loading, setLoading] = useState(false)
  const [performanceData, setPerformanceData] = useState(null)
  const [chartData, setChartData] = useState([
    {
      name: 'Performance',
      fill: '#FFC750',
      backGround: 'rgba(255, 199, 80, 0.3)',
      percentage: 70
    },
    {
      name: 'Accessibility',
      fill: '#6BCF1E',
      backGround: 'rgba(107, 207, 30, 0.3)',
      percentage: 87
    },
    {
      name: 'Best Practices',
      fill: '#C61B1A',
      backGround: 'rgba(198, 27, 26, 0.3)',
      percentage: 90
    },
    {
      name: 'Performance',
      fill: '#6BCF1E',
      backGround: 'rgba(107, 207, 30, 0.3)',
      percentage: 82
    },
  ])
  const [pageInsightDetails, setPageInsightDetails] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState("")
  const [showPagesOption, setShowPageOption] = useState(false);
  const [showMessage, setShowMessage] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [error, setError] = useState(null);

  const screenTogglerData = [
    { name: 'Mobile', icon: <LuSmartphone size={20} /> },
    { name: 'Desktop', icon: <BsLaptop size={20} /> }
  ]

  const [selectedScreen, setSelectedScreen] = useState(screenTogglerData.length - 1);

  const handleScreenSelect = (index) => {
    setSelectedScreen((prevState) => prevState === index ? null : index)
  }

  const savePerformanceToDB = async (data) => {
    const token = sessionStorage.getItem('authToken');
        const headers = {
          Authorization: `Bearer ${token}`,
          'x-api-key': security_key
        };
    
    try {
      const apiEndpoint = `${Url}/api/v1/performance/web-performance/add`;
      const response = await axios.post(apiEndpoint, data,{headers:headers});
      console.log("Performance data saved successfully:", response.data);
    } catch (error) {
      console.error("Error saving performance data:", error);
    }
  };

  const fetchWebsitePerformanceData = async (pageUrl) => {
    const strategy = selectedScreen === 0 ? "mobile" : "desktop";
    const api = `https://www.googleapis.com/pagespeedonline/v5/runPagespeed?url=${pageUrl}&key=AIzaSyDHTJtwucktFk_RTSuvvRM5TTDn3k5Th1Y&strategy=${strategy}`;
    try {
      setLoading(true);
      const response = await axios.get(api);
      const performanceData = response.data.lighthouseResult;

      if (!performanceData) {
        console.error("No performance data found.");
        return;
      }

      const performancePayload = {
        device: strategy,
        url: pageUrl,
        score: performanceData.categories.performance?.score * 100 || "N/A",
        fcp: performanceData.audits['first-contentful-paint']?.numericValue || "N/A",
        lcp: performanceData.audits['largest-contentful-paint']?.numericValue || "N/A",
        tbt: performanceData.audits['total-blocking-time']?.numericValue || "N/A",
        cls: performanceData.audits['cumulative-layout-shift']?.numericValue || "N/A",
        si: performanceData.audits['speed-index']?.numericValue || "N/A"
      };

      console.log("Performance Data:", performancePayload);

      await savePerformanceToDB(performancePayload);

      setPerformanceData(performanceData);
    } catch (error) {
      console.error("Error fetching performance data:", error);
    }
    setLoading(false);
  };

  console.log("performance score", parseInt(performanceData?.categories?.performance?.score * 100))

  const handlePAgeInsightDetails = () => {
    setPageInsightDetails(!pageInsightDetails)
  }

  const dropdownData = [
    { name: 'Home', url: baseURL },
    { name: 'Categories', url: `${baseURL}/living-rooms` },
    { name: 'Products List', url: `${baseURL}/living-rooms/living-room-sets` },
    { name: 'Product Details', url: `${baseURL}/product/cohen-sectional` },
    { name: 'About', url: `${baseURL}/about-us` },
    { name: 'contact', url: `${baseURL}/contact-us` },
    { name: 'Financing', url: `${baseURL}/financing` },
    { name: 'Shipping & Delivery', url: `${baseURL}/shipping-and-delivery` },
    { name: 'Terms & Conditions', url: `${baseURL}/terms-and-conditions` },
    { name: 'Privacy Policy', url: `${baseURL}/privacy-policy` },
    { name: 'Return Policy', url: `${baseURL}/return-policy` },
  ]

  const [webPageUrl, setWebPageUrl] = useState(() => dropdownData?.[0]?.url)

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const handleSelectOption = (item) => {
    setSelectedOption(item.name)
    setWebPageUrl(item.url)
    setShowPageOption(false)
    console.log("item url", item.url)
    setIsOpen(false)
  }

  const handleCheckPerformance = () => {
    fetchWebsitePerformanceData(webPageUrl)
  }

  const handleShowPageBody = () => {
    setShowPageOption(!showPagesOption)
  }

  console.log("check chart score", performanceData?.categories?.performance?.score)

  const handleCloseMessageModal = () => {
    setShowMessage(false);
  };

  useEffect(() => {
    if (showMessage === true) {
      const timeOut = setTimeout(() => {
        setShowMessage(false);
      }, 3000);

      return () => clearTimeout(timeOut);
    }
  }, [showMessage]);

  const commonProps = {
    setShowMessage,
    setToastMessage,
    setError,
  };

  return (
    <div className="HomePage" style={{ gap: '20px' }}>
      {/* {loading && <MainLoader />} */}

      <div className='performance-section-main'>

        <div className='performance-report-section'>

          <div className='performance-head-section'>
            <h3 className='performance-report-heading'>Performance Report</h3>

            <div className='insight-screen-toggler-section'>
              {screenTogglerData.map((item, index) => (
                <div
                  key={index}
                  className={`desktop-screen-single-toggler ${selectedScreen === index ? 'selected-desktop-screen-single-toggler' : ''}`}
                  onClick={() => handleScreenSelect(index)}
                >
                  {item.icon}
                </div>
              ))}
            </div>

            <div className='performance-report-search-bar-container'>

              <div className="url-dropdown-main">
                <button className="dropdown-toggle" onClick={toggleDropdown}>
                  {selectedOption !== "" ? selectedOption : 'Select Option'}
                </button>

                {isOpen && (
                  <ul className="url-dropdown-menu">
                    {dropdownData.map((item, index) => (
                      <li key={index} onClick={() => {
                        handleSelectOption(item);
                      }}>{item.name}</li>
                    ))}
                  </ul>
                )}
              </div>

              <button onClick={handleCheckPerformance}>Analyze</button>
            </div>
          </div>

          <div className='performance-body'>
            {performanceData?.categories?.performance?.score !== undefined ? (

              <div className='performance-page-show'>

                <div className='performance-page-chart'>
                  <div className='performance-count-single-chart-and-title-div'>
                    <CircularProgressbar
                      value={performanceData?.categories?.performance?.score}
                      text={`${Number(performanceData?.categories?.performance?.score * 100).toFixed(0)}%`}
                      background={true}
                      maxValue={1}
                      className='circle-progress-bar'
                      styles={{
                        root: {
                          width: '150px',
                          height: '150px',
                        },
                        path: {
                          stroke: parseInt(performanceData?.categories?.performance?.score * 100) > 89 && parseInt(performanceData?.categories?.performance?.score * 100) < 100 ? (
                            "#6BCF1E"
                          ) : parseInt(performanceData?.categories?.performance?.score * 100) > 50 && parseInt(performanceData?.categories?.performance?.score * 100) < 89 ? (
                            "#FFC750"
                          ) : (
                            "#C61B1A"
                          ),
                          strokeLinecap: 'round',
                        },
                        trail: {
                          stroke: parseInt(performanceData?.categories?.performance?.score * 100) > 89 && parseInt(performanceData?.categories?.performance?.score * 100) < 100 ? (
                            'rgba(107, 207, 30, 0.3)'
                          ) : parseInt(performanceData?.categories?.performance?.score * 100) > 50 && parseInt(performanceData?.categories?.performance?.score * 100) < 89 ? (
                            'rgba(255, 199, 80, 0.3)'
                          ) : (
                            'rgba(198, 27, 26, 0.3)'
                          ),
                        },
                        text: {
                          fill: parseInt(performanceData?.categories?.performance?.score * 100) > 89 && parseInt(performanceData?.categories?.performance?.score * 100) < 100 ? (
                            "#6BCF1E"
                          ) : parseInt(performanceData?.categories?.performance?.score * 100) > 50 && parseInt(performanceData?.categories?.performance?.score * 100) < 89 ? (
                            "#FFC750"
                          ) : (
                            "#C61B1A"
                          ),
                          fontSize: '30px',
                          fontWeight: '600'
                        },
                        background: {
                          fill: parseInt(performanceData?.categories?.performance?.score * 100) > 89 && parseInt(performanceData?.categories?.performance?.score * 100) < 100 ? (
                            'rgba(107, 207, 30, 0.3)'
                          ) : parseInt(performanceData?.categories?.performance?.score * 100) > 50 && parseInt(performanceData?.categories?.performance?.score * 100) < 89 ? (
                            'rgba(255, 199, 80, 0.3)'
                          ) : (
                            'rgba(198, 27, 26, 0.3)'
                          ),
                        },
                      }}
                    />
                    <p>Performance</p>
                  </div>
                </div>

              </div>

            ) : (

              <div className='check-performance-page-select-main-container'>
                <div className='check-performance-dropdown-main'>

                  <div className='dropdown-main'>

                    <div className='dropdown-performance-head' onClick={handleShowPageBody}>
                      <h3>{selectedOption !== "" ? selectedOption : 'Select Option'}</h3>

                      <IoIosArrowDown size={20} />
                    </div>

                    <ul className={`dropdown-performance-body ${showPagesOption ? 'show-dropdown-body' : ''}`}>
                      {dropdownData.map((item, index) => (
                        <li key={index} onClick={() => {
                          handleSelectOption(item);
                        }}>{item.name}</li>
                      ))}
                    </ul>

                  </div>

                  <button className={loading ? 'show-loader' : ''} onClick={handleCheckPerformance}>{loading ? "" : "Analyze Performance"}</button>
                </div>
              </div>

            )}


            {performanceData && <div className='performance-matrices'>

              <div className='performance-matrices-head'>
                <div className='performance-matrices-indications'>
                  <p className='performance-matrices-heading'>Matrices</p>
                  <span>
                    <IoTriangleSharp size={25} style={{ color: '#C61B1A' }} />
                    <p>0 - 49</p>
                  </span>
                  <span>
                    <FaSquareFull size={25} style={{ color: '#FFC750' }} />
                    <p>50 - 89</p>
                  </span>
                  <span>
                    <FaCircle size={25} style={{ color: '#6BCF1E' }} />
                    <p>90 - 100</p>
                  </span>
                </div>
                <h3 className='performance-matrices-expend-heading' onClick={handlePAgeInsightDetails}>Expand View</h3>
              </div>

              <div className='performance-matrices-details-container'>

                {/* FCP */}
                <div className='performance-matrices-details-columns'>

                  <span className='performance-matrices-details-columns-heading'>
                    {
                      parseFloat(performanceData?.audits?.['first-contentful-paint']?.displayValue) > 0 && parseFloat(performanceData?.audits?.['first-contentful-paint']?.displayValue) < 0.9 ? (
                        <FaCircle size={30} color="#6BCF1E" />
                      ) : parseFloat(performanceData?.audits?.['first-contentful-paint']?.displayValue) > 0.9 && parseFloat(performanceData?.audits?.['first-contentful-paint']?.displayValue) < 1.6 ? (
                        <FaSquareFull size={30} color="#FFC750" />
                      ) : (
                        <IoTriangleSharp size={30} color="#C61B1A" />
                      )
                    }
                    <p>First Contentful paint</p>
                  </span>

                  <p
                    className='performance-ping-data'
                    style={
                      {
                        color: parseFloat(performanceData?.audits?.['first-contentful-paint']?.displayValue) > 0 && parseFloat(performanceData?.audits?.['first-contentful-paint']?.displayValue) < 0.9 ? "#6BCF1E" :
                          parseFloat(performanceData?.audits?.['first-contentful-paint']?.displayValue) > 0.9 && parseFloat(performanceData?.audits?.['first-contentful-paint']?.displayValue) < 1.6 ? "#FFC750" :
                            "#C61B1A"
                      }
                    }
                  >
                    {performanceData?.audits?.['first-contentful-paint']?.displayValue}
                  </p>

                  <div className={`performance-matrices-detail-section ${pageInsightDetails ? 'show-page-insight-details' : ''}`}>
                    <p>First Contentful Paint marks the time at which the first text or image is painted. <a href='https://developer.chrome.com/docs/lighthouse/performance/first-contentful-paint/?utm_source=lighthouse&utm_medium=lr'> Learn more about the First Contentful Paint metric. </a></p>
                  </div>
                </div>

                {/* LCP */}
                <div className='performance-matrices-details-columns'>
                  <span className='performance-matrices-details-columns-heading'>
                    {
                      parseFloat(performanceData?.audits?.['largest-contentful-paint']?.displayValue) > 0 && parseFloat(performanceData?.audits?.['largest-contentful-paint']?.displayValue) < 2.5 ? (
                        <FaCircle size={30} color="#6BCF1E" />
                      ) : parseFloat(performanceData?.audits?.['largest-contentful-paint']?.displayValue) > 2.5 && parseFloat(performanceData?.audits?.['largest-contentful-paint']?.displayValue) < 4 ? (
                        <FaSquareFull size={30} color="#FFC750" />
                      ) : (
                        <IoTriangleSharp size={30} color="#C61B1A" />
                      )
                    }
                    <p>Largest Contentful paint</p>
                  </span>
                  <p
                    className='performance-ping-data'
                    style={
                      {
                        color: parseFloat(performanceData?.audits?.['largest-contentful-paint']?.displayValue) > 0 && parseFloat(performanceData?.audits?.['largest-contentful-paint']?.displayValue) < 2.5 ? "#6BCF1E" :
                          parseFloat(performanceData?.audits?.['largest-contentful-paint']?.displayValue) > 2.5 && parseFloat(performanceData?.audits?.['largest-contentful-paint']?.displayValue) < 4 ? "#FFC750" :
                            "#C61B1A"
                      }
                    }
                  >
                    {performanceData?.audits?.['largest-contentful-paint']?.displayValue}</p>
                  <div className={`performance-matrices-detail-section ${pageInsightDetails ? 'show-page-insight-details' : ''}`}>
                    <p>Largest Contentful Paint marks the time at which the largest text or image is painted. <a href='https://developer.chrome.com/docs/lighthouse/performance/lighthouse-largest-contentful-paint/?utm_source=lighthouse&utm_medium=lr'> Learn more about the Largest Contentful Paint metric </a></p>
                  </div>
                </div>

                {/* Blocking Time */}
                <div className='performance-matrices-details-columns'>
                  <span className='performance-matrices-details-columns-heading'>
                    {
                      parseInt(performanceData?.audits?.['total-blocking-time']?.displayValue) > 0 && parseInt(performanceData?.audits?.['total-blocking-time']?.displayValue) < 200 ? (
                        <FaCircle size={30} color="#6BCF1E" />
                      ) : parseInt(performanceData?.audits?.['total-blocking-time']?.displayValue) > 200 && parseInt(performanceData?.audits?.['total-blocking-time']?.displayValue) < 600 ? (
                        <FaSquareFull size={30} color="#FFC750" />
                      ) : (
                        <IoTriangleSharp size={30} color="#C61B1A" />
                      )
                    }
                    <p>Total Blocking Time</p>
                  </span>
                  <p
                    className='performance-ping-data'
                    style={{
                      color: parseInt(performanceData?.audits?.['total-blocking-time']?.displayValue) > 0 && parseInt(performanceData?.audits?.['total-blocking-time']?.displayValue) < 200 ? "#6BCF1E" :
                        parseInt(performanceData?.audits?.['total-blocking-time']?.displayValue) > 200 && parseInt(performanceData?.audits?.['total-blocking-time']?.displayValue) < 600 ? "#FFC750" :
                          "#C61B1A"
                    }}
                  >
                    {performanceData?.audits?.['total-blocking-time']?.displayValue}
                  </p>
                  <div className={`performance-matrices-detail-section ${pageInsightDetails ? 'show-page-insight-details' : ''}`}>
                    <p>Sum of all time periods between FCP and Time to Interactive, when task length exceeded 50ms, expressed in milliseconds. <a href='https://developer.chrome.com/docs/lighthouse/performance/lighthouse-total-blocking-time/?utm_source=lighthouse&utm_medium=lr'> Learn more about the Total Blocking Time metric. </a></p>
                  </div>
                </div>

                {/* CLS */}
                <div className='performance-matrices-details-columns'>
                  <span className='performance-matrices-details-columns-heading'>
                    {
                      parseFloat(performanceData?.audits?.['cumulative-layout-shift']?.displayValue) > 0 && parseFloat(performanceData?.audits?.['cumulative-layout-shift']?.displayValue) < 0.1 ? (
                        <FaCircle size={30} color="#6BCF1E" />
                      ) : parseFloat(performanceData?.audits?.['cumulative-layout-shift']?.displayValue) > 0.1 && parseFloat(performanceData?.audits?.['cumulative-layout-shift']?.displayValue) < 0.25 ? (
                        <FaSquareFull size={30} color="#FFC750" />
                      ) : (
                        <IoTriangleSharp size={30} color="#C61B1A" />
                      )
                    }
                    <p>Cumulative Layout Shift</p>
                  </span>
                  <p
                    className='performance-ping-data'
                    style={
                      {
                        color: parseFloat(performanceData?.audits?.['cumulative-layout-shift']?.displayValue) > 0 && parseFloat(performanceData?.audits?.['cumulative-layout-shift']?.displayValue) < 0.1 ? "#6BCF1E" :
                          parseFloat(performanceData?.audits?.['cumulative-layout-shift']?.displayValue) > 0.1 && parseFloat(performanceData?.audits?.['cumulative-layout-shift']?.displayValue) < 0.25 ? "#FFC750" :
                            "#C61B1A"

                      }
                    }
                  >
                    {performanceData?.audits?.['cumulative-layout-shift']?.displayValue}
                  </p>
                  <div className={`performance-matrices-detail-section ${pageInsightDetails ? 'show-page-insight-details' : ''}`}>
                    <p>Cumulative Layout Shift measures the movement of visible elements within the viewport. <a href='https://web.dev/articles/cls?utm_source=lighthouse&utm_medium=lr'> Learn more about the Cumulative Layout Shift metric. </a></p>
                  </div>
                </div>

                {/* Spee index */}
                <div className='performance-matrices-details-columns'>
                  <span className='performance-matrices-details-columns-heading'>
                    {
                      parseFloat(performanceData?.audits?.['speed-index']?.displayValue) > 0 && parseFloat(performanceData?.audits?.['speed-index']?.displayValue) < 3.4 ? (
                        <FaCircle size={30} color="#6BCF1E" />
                      ) : parseFloat(performanceData?.audits?.['speed-index']?.displayValue) > 3.4 && parseFloat(performanceData?.audits?.['speed-index']?.displayValue) < 5.8 ? (
                        <FaSquareFull size={30} color="#FFC750" />
                      ) : (
                        <IoTriangleSharp size={30} color="#C61B1A" />
                      )
                    }
                    <p>Speed Index</p>
                  </span>
                  <p
                    className='performance-ping-data'
                    style={
                      {
                        color: parseFloat(performanceData?.audits?.['speed-index']?.displayValue) > 0 && parseFloat(performanceData?.audits?.['speed-index']?.displayValue) < 3.4 ? "#6BCF1E" :
                          parseFloat(performanceData?.audits?.['speed-index']?.displayValue) > 3.4 && parseFloat(performanceData?.audits?.['speed-index']?.displayValue) < 5.8 ? "#FFC750" :
                            "#C61B1A"
                      }
                    }
                  >
                    {performanceData?.audits?.['speed-index']?.displayValue}
                  </p>
                  <div className={`performance-matrices-detail-section ${pageInsightDetails ? 'show-page-insight-details' : ''}`}>
                    <p>Speed Index shows how quickly the contents of a page are visibly populated. <a href='https://developer.chrome.com/docs/lighthouse/performance/speed-index/?utm_source=lighthouse&utm_medium=lr'>Learn more about the Speed Index metric. </a></p>
                  </div>
                </div>

              </div>
            </div>}

          </div>

          <InsightsHistory {...commonProps} />

        </div>
      </div>

      <BottomToust
        showMessage={showMessage}
        message={toastMessage}
        handleCloseMessageModal={() => handleCloseMessageModal()}
      />
    </div>
  );
};

export default InSights;